/** Shared by every control's `touch` size and the phone full-screen dialog, so the 44px target (WCAG 2.5.5) changes in one place. */
export const TOUCH_LAYOUT_CLASSES = {
  control: 'h-11',
  nativeSelect: '[&>select]:h-11',
  phoneFullScreenDialog:
    'flex max-h-[90dvh] flex-col max-sm:top-0 max-sm:left-0 max-sm:h-dvh max-sm:max-h-dvh max-sm:w-full max-sm:max-w-full max-sm:translate-x-0 max-sm:translate-y-0 max-sm:rounded-none',
} as const;
